/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Form, Input, Select, Modal, message } from 'antd';
import { EMPLOYEE_EXIT_REASONS } from '../../../config/config';
import { DataService } from '../../../config/dataService/dataService';

const { Option } = Select

function EndEmployement({ visible, onFinish, onClose, empID }) {
  const [busy, setBusy] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      setBusy(true);
      const data = { ...values, id: empID }
      // Submit the form data
      const response = await DataService.post('/emp/end-emp', data);

      if (response.data.status) {
        message.success(response.data.message, () => {
          onFinish();
          onClose();
        });
      } else {
        setBusy(false);
        message.error(`Error: ${response.data.message}`);
      }
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`);
    }
  }
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title="End Employment Dialog"
      okText='End Employment'
      cancelText="Cancel"
      width="50%"
      confirmLoading={busy}
      onOk={() => form.submit()}
      cancelButtonProps={{ disabled: busy }}
      destroyOnClose
    >
      <Form
        layout="horizontal"
        form={form}
        name="employee_form"
        onFinish={handleSubmit}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        disabled={busy}
      >
        <Form.Item
          name="end_type_id"
          label="Select Reason"
          rules={[{ required: true, message: 'Please select an end employment reason!' }]}
        >
          <Select
            placeholder="Select End Employment Reason"
            showSearch // Enables search functionality
            optionFilterProp="children" // Search by the label text
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            } // Custom filter for case-insensitive search
          >
            {EMPLOYEE_EXIT_REASONS.map((reason) => (
              <Option key={reason.id} value={reason.id}>
                {reason.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="end_remarks"
          label="Remarks"
          rules={[{ required: true, message: 'Please input the remarks!' }]}
        >
          <Input placeholder="Enter Remarks" />
        </Form.Item>
        <Form.Item
          label="Note"
          rules={[]}
        >
          <p className='text-sm text-yellow-600'>
            End Employment will disable active card of employee
          </p>
          <p className='text-sm text-yellow-600'>
            End Employment will disable trainings employee
          </p>
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default EndEmployement;
